import { render, staticRenderFns } from "./ipageFlutter.vue?vue&type=template&id=4ad84734&"
import script from "./ipageFlutter.vue?vue&type=script&lang=js&"
export * from "./ipageFlutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports